import { login, loginByPassword } from '@/api/login'
import { teamDetail, invited, memberDetail} from '@/api/team'
const state = {
    user: null,
    team:{},
}
const mutations = {
    SET_USER: (state, userinfo) => {
        state.user = userinfo
        localStorage.setItem("user", JSON.stringify( userinfo))
    },
    SET_TEAM:(state,detail)=>{
        state.team = detail
        localStorage.setItem("team", JSON.stringify( detail))
    },
    SET_USERDETAIL:(state,detail)=>{
        state.user.detail=detail
        localStorage.setItem("user", JSON.stringify( state.user))
    }
}
const actions = {
    /* 
        @params
        {
            "username": "**********"
            "code":'******'
        }
        @return 
        {
            "code": "200",
            "data": {
                "growLoginPoint": "10",
                "hasWallet": "0",
                "customerImg": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTK2ialpFmBxHKru4tmt1AHEPon0AbQpu9mhTvicE8cwUfKVd6KRpC844K7fMuCicd8eUpWoCausW85UA/132",
                "tokenKey": "362140F3F8348B424CD788DFE4D76357",
                "username": "13053273111",
                "level": "2",
                "loginPoint": "0",
                "token": "82bcb15d13bbd38ba68918f526a7eb13",
                "userId": 245333,
                "customerNickname": "babycold",
                "openid": "xxxxxxxxxxxxxxxx",
                "hasPassword": true,
                "mobile": "1305327111"
            },
            "message": "登录成功"

        }
    */
    login({ commit, dispatch }, params) {
        localStorage.clear();
        return new Promise((resolve, reject) => {
            if (!params.code && !params.password){
                reject('对不起，参数错误')
            }
            login(params).then(res => {
                if (res.code == "200") {
                    commit('SET_USER', res.data)
                    dispatch('team',{uid:res.data.userId}).then(teamres=>{
                        res.data.team = teamres
                        commit('SET_USER', res.data)
                        resolve(res)
                    })
                } else {
                    reject(res.message)
                }
            })
        })
    },
    setUser({commit,dispatch},params){
        commit('SET_USER', params)
    },
    setTeam({ commit, dispatch }, params) {
        commit('SET_TEAM', params)
        commit('SET_USERDETAIL',params)
    },
    team({commit,dispatch},params){
        return new Promise((resolve, reject) => {
            teamDetail(params).then(res=>{

                if (res.code == "0"){
                    commit("SET_TEAM", res.o_ret)
                    res.o_ret.list.forEach(element => {
                        if (element.uid == params.uid){
                            commit("SET_USERDETAIL",element)
                        }
                    });
                }

                resolve(res)
            })
        })
    },
    invited({ commit, dispatch }){
        return new Promise((resolve, reject) => {
            if (state.user && state.user.username){
                invited(state.user.username).then(res => {
                    resolve(res)
                })
            }else{
                reject("对不起，您已丢失登录信息，请重新登录！")
            }
            
        })
    },
    memberDetail({},params){
        return new Promise((resolve, reject) => {
            memberDetail({ inviteId:params}).then(res => {
                    resolve(res)
                })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js